<template>
  <v-dialog v-model="visible" max-width="500">
    <v-card @click.stop>
      <v-card-title class="headline">
        {{ notification.data.message.title }}
      </v-card-title>

      <v-card-text>
        <div class="mt-3">
          {{ notification.data.message.text }}
        </div>

        <v-alert
          v-if="notification.data.message.mandatory"
          type="warning"
          dense
          text
          class="mt-4"
        >
          This notification requires acknowledgment before continuing.
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="acknowledge">
          {{ notification.data.message.mandatory ? 'Mark as Read' : 'Close' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "NotificationPopupMessage",
  props: {
    notification: {
      type: Object,
      required: true,
    },
    value: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    acknowledge() {
      this.$emit("acknowledge", this.notification);
      this.visible = false;
    },
  },
};
</script>
